import React from 'react';
import styled from 'styled-components';

const Title = styled.h2`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 800;
    font-size: 2.75rem;
    line-height: 2.75rem;
    text-align: center;
    @media screen and (max-width: 600px) {
        font-size: 22px;
        line-height: 27px;
    }
`;

export const TitleBlock = ({ children }) => <Title>{children}</Title>;
